export const SIGNUP_URL = '/signup';